// extracted by mini-css-extract-plugin
export default {"form":"style_form__T3m9u","form_content":"style_form_content__ydri4","form_row":"style_form_row__TVwrv","form_row-checkbox":"style_form_row-checkbox__lVJNf"};